import React, { ChangeEvent, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import Separator from '~/components/Separator';
import ToggleDefault from '~/components/ToggleDefault';
import { useProduto } from '~/pages/Produto/hooks/useProduto';
import { tipoMultiplicacao } from '../../constants';
import {
  InputAsyncSelect,
  InputDate,
  InputMoney,
  InputNumber2,
  InputNumberDias,
  InputPercent,
  InputSelect,
  InputText,
} from '~/components/NovosInputs';
import { moedaFormatada } from '~/components/NovosInputs/InputMoney/formatMask';
import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';
import { InterfaceContainer } from './styles';
import { tipos_combustiveis, tipos_composicao } from '../../constants';
import { FlagsState, Associado, Select } from '../../types';
import { format } from 'date-fns';
import { useProdutoQueries } from '../../hooks/useQueriesProduto';

export const AbaInterface: React.FC = () => {
  const {
    hasVariacaoGrade,
    setValue,
    register,
    control,
    clearErrors,
    getValues,
    formState: { errors },
    watch,
    flags,
    ChangeFlags,
    associadosFilho,
    associadosPai,
  } = useProduto();
  const { vasilhames, unidades } = useProdutoQueries();
  const tipoMovimentacao = watch('tipo_movimentacao');

  useEffect(() => {
    const values = hasVariacaoGrade
      ? {
          value: 0,
          label: 'Direta',
        }
      : tipos_composicao.find((item: Select) => {
          return item.value === tipoMovimentacao?.value;
        }) ?? {
          value: 0,
          label: 'Direta',
        };
    setValue('tipo_movimentacao', values);
  }, [tipoMovimentacao?.value, setValue, hasVariacaoGrade]);

  function handleChangeFlgRastreavel() {
    setValue('num_lote_rast', '');
    setValue('qtd_lote_rast', 0);
    setValue('cod_agreg_rast', 0);
    setValue('dta_fabricacao_rast', format(new Date(), 'yyyy-MM-dd'));
    ChangeFlags((prev: FlagsState) => ({
      flg_rastreavel: !prev.flg_rastreavel,
    }));
  }

  const setUnidadeTributavel = (codANP: string) => {
    if (codANP === 'null') {
      setValue('des_unidade_tributavel', { value: null, label: 'Nenhum' });
      return;
    }
    const unPorCodANP = () => {
      switch (codANP) {
        case '210203001':
          return 'KG';
        case '820101012':
          return 'LT';
        default:
          return 'LT';
      }
    };

    const un = unidades.data?.unCompras.find(
      (item: any) => String(item.value).trim() === unPorCodANP(),
    );

    setValue('des_unidade_tributavel', un);
  };

  const handleChangeTipoMovimentacao = (selected: Select) => {
    if (selected.value === tipoMovimentacao?.value) return;
    if (selected.value === 1) {
      ChangeFlags({
        flg_atualiza_custo_decomp: false,
        flg_explosao_venda: false,
        flg_explosao_compra: true,
      });
      setValue('tipo_movimentacao', selected);
      return setValue('per_perda', '0,00');
    }
    ChangeFlags({
      flg_atualiza_custo_decomp: false,
      flg_explosao_venda: false,
      flg_explosao_compra: false,
    });
    setValue('tipo_movimentacao', selected);
    setValue('per_perda', '0,00');
  };

  return (
    <InterfaceContainer>
      <Row>
        <Col xs={6} sm={6} md={3} lg={2} xl={2}>
          <ToggleDefault
            labelText="Peso Variável?"
            setChecked={flags.flg_ipv}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_ipv: !prev.flg_ipv,
              }));
            }}
          />
        </Col>
        <Col xs={6} sm={6} md={3} lg={2} xl={2}>
          <ToggleDefault
            labelText="Enviar para Balança?"
            setChecked={flags.flg_envia_balanca}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_envia_balanca: !prev.flg_envia_balanca,
              }));
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={3} lg={2} xl={2} style={{ marginTop: '7px' }}>
          <InputNumberDias
            label="Validade"
            min={0}
            value={watch('qtd_dias_validade')}
            placeholder=""
            isRequired={false}
            setInvalid={false}
            isDisabled={false}
            onChange={(value: any) => {
              setValue('qtd_dias_validade', Math.abs(value));
            }}
            inputWidth="100%"
          />
        </Col>
        <Col sm={12} md={3} lg={2} xl={2}>
          <InputText
            maxLength={5}
            label="Tecla Balança"
            placeholder=""
            register={register}
            isError={!!errors.tecla_balanca}
            name="tecla_balanca"
            onInput={(ev: ChangeEvent<HTMLInputElement>) => {
              const { value } = ev.target;

              setValue('tecla_balanca', value);
            }}
          />
        </Col>
        <Col sm={12} md={6} lg={4} xl={3}>
          <InputAsyncSelect
            label="Receita"
            name="cod_receita"
            maxLength={50}
            placeholder="Selecione a Receita"
            register={register}
            isError={!!errors.cod_receita}
            control={control}
            includeNoneOption
            changeSelected={(selected: any) => {
              selected.value = selected.cod_receita || selected.value;

              setValue('cod_receita', {
                value: selected.value,
                label: selected.label,
              });
            }}
            api={{
              route: '/receita',
              method: 'get',
              fields: ['des_receita'],
              searchBeforeFilter: true,
            }}
          />
        </Col>
        <Col sm={12} md={6} lg={4} xl={3}>
          <InputAsyncSelect
            label="Informação Nutricional"
            name="cod_info_nutricional"
            maxLength={50}
            placeholder="Selecione a Inf. Nutr."
            register={register}
            isError={!!errors.cod_info_nutricional}
            control={control}
            includeNoneOption
            changeSelected={(selected: any) => {
              selected.value = selected.cod_info_nutricional || selected.value;
              setValue('cod_info_nutricional', {
                value: selected.value,
                label: selected.label,
              });
            }}
            api={{
              route: '/informacaoNutricional',
              method: 'get',
              fields: ['des_info_nutricional'],
              searchBeforeFilter: true,
            }}
          />
        </Col>
        <Col sm={12} md={6} lg={4} xl={2}>
          <InputAsyncSelect
            label="Tara"
            name="cod_tara"
            maxLength={50}
            placeholder="Selecione a Tara"
            register={register}
            isError={!!errors.cod_tara}
            control={control}
            includeNoneOption
            changeSelected={(selected: any) => {
              selected.value = selected.cod_tara || selected.value;

              setValue('cod_tara', {
                value: selected.value,
                label: selected.label,
              });
            }}
            api={{
              route: '/tara',
              method: 'get',
              fields: ['des_tara'],
              searchBeforeFilter: true,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Separator labelText="PDV" />
        <Col sm={12} md={2} lg={2} xl={2}>
          <ToggleDefault
            labelText="Envia PDV?"
            setChecked={flags.flg_envia_pdv}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_envia_pdv: !prev.flg_envia_pdv,
              }));
            }}
          />
        </Col>
        <Col sm={12} md={2} lg={2} xl={2}>
          <ToggleDefault
            labelText="Consumo Monitorado?"
            setChecked={flags.flg_consumo_monitorado}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_consumo_monitorado: !prev.flg_consumo_monitorado,
              }));
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={4} lg={3} xl={2}>
          <InputSelect
            options={tipoMultiplicacao as SelectType[]}
            label="Permite Multiplicação"
            name="tipo_multiplicacao"
            register={register}
            isError={!!errors.tipo_multiplicacao}
            control={control}
            changeSelected={(selected) => {
              setValue('tipo_multiplicacao', selected);
            }}
          />
        </Col>
        <Col sm={12} md={7} lg={4}>
          <InputSelect
            label="Vasilhame"
            name="cod_vasilhame"
            placeholder="Código ou Descrição do Vasilhame"
            options={vasilhames.data as SelectType[]}
            control={control}
            register={register}
            isError={false}
            changeSelected={(selected) => {
              setValue('cod_vasilhame', selected);
            }}
          />
        </Col>
        <Col sm={12} md={12}>
          <Separator labelText="Etiqueta" />
        </Col>
        <Col sm={12} md={3} lg={2} xl={2}>
          <InputNumber2
            label="Quantidade"
            min={0}
            max={9999}
            maxLength={4}
            placeholder=""
            name="qtd_etiqueta"
            register={register}
            control={control}
            isError={!!errors.qtd_etiqueta}
            onBlur={(event: ChangeEvent<HTMLInputElement>) => {
              if (event.target.value === '') setValue('qtd_etiqueta', 1);
            }}
            onChange={(ev: any) => {
              const value = parseFloat(ev.target.value.slice(0, 4));

              if ((value >= 0 && value <= 9999) || ev.target.value === '') {
                setValue('qtd_etiqueta', value);
              }
            }}
          />
        </Col>

        <Col sm={12} md={12}>
          <Separator labelText="Movimentação" />
        </Col>
        <Col>
          <InputSelect
            id="tipoMov"
            label="Tipo de Movimentação"
            options={
              hasVariacaoGrade
                ? tipos_composicao.slice(0, 1)
                : (tipos_composicao as SelectType[])
            }
            name="tipo_movimentacao"
            register={register}
            isError={!!errors.tipo_movimentacao}
            control={control}
            changeSelected={(selected) => {
              handleChangeTipoMovimentacao(selected);
            }}
          />
        </Col>
        <Col>
          <InputPercent
            label="Perda de Decomposição"
            min={0}
            max={100}
            maxLength={7}
            decimals={2}
            placeholder="0,00"
            isDisabled={tipoMovimentacao?.value !== 1}
            name="per_perda"
            register={register}
            control={control}
            isError={!!errors.per_perda}
            showIcon
            onInput={(ev: any) => {
              const serializedValue = moedaFormatada(ev.target.value);

              setValue('per_perda', serializedValue);
            }}
          />
        </Col>
        <Col>
          <ToggleDefault
            labelText="Explosão na Compra?"
            disabled={tipoMovimentacao?.value === 0}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_explosao_compra: !prev.flg_explosao_compra,
                flg_atualiza_custo_decomp: false,
              }));
            }}
            setChecked={flags.flg_explosao_compra}
          />
        </Col>
        <Col>
          <ToggleDefault
            labelText="Atualiza Custos na Explosão?"
            disabled={
              !flags.flg_explosao_compra || tipoMovimentacao?.value !== 1
            }
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_atualiza_custo_decomp: !prev.flg_atualiza_custo_decomp,
              }));
            }}
            setChecked={flags.flg_atualiza_custo_decomp}
          />
        </Col>

        <Col>
          <ToggleDefault
            labelText="Explosão na Venda?"
            disabled={
              tipoMovimentacao?.value === 1 ||
              tipoMovimentacao?.value === 0 ||
              (watch('tipo_associado') === 1
                ? associadosPai
                : associadosFilho
              ).some((item: Associado) => Number(item.qtd_estoque) > 0)
            }
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_explosao_venda: !prev.flg_explosao_venda,
              }));
            }}
            setChecked={flags.flg_explosao_venda}
          />
        </Col>

        <Col sm={12} md={12}>
          <Separator labelText="Combustível" />
        </Col>
        <Col sm={2} md={2}>
          <InputSelect
            label="Código ANP"
            options={tipos_combustiveis as SelectType[]}
            name="cod_anp"
            placeholder="Nenhum"
            register={register}
            isError={!!errors.cod_anp}
            control={control}
            ListaWidth="230%"
            title={`${getValues('cod_anp')?.label || ''}`}
            changeSelected={(selected) => {
              setValue('cod_anp', selected);
              setValue('per_glp', '0,00');
              setValue('per_gnn', '0,00');
              setValue('per_gni', '0,00');
              setValue('val_partida', '');
              setUnidadeTributavel(String(selected.value));
              clearErrors('per_glp');
              clearErrors('val_partida');
            }}
          />
        </Col>
        <Col sm={2} md={2}>
          <InputPercent
            label="GLP"
            min={0}
            max={100}
            maxLength={7}
            decimals={2}
            placeholder="0,00"
            isDisabled={false}
            name="per_glp"
            id="per_glp"
            register={register}
            control={control}
            isError={!!errors.per_glp}
            showIcon
            onInput={(ev: any) => {
              const serializedValue = moedaFormatada(ev.target.value);
              setValue('per_glp', serializedValue);
              clearErrors('per_glp');
            }}
          />
        </Col>
        <Col sm={2} md={2}>
          <InputPercent
            label="GNN"
            min={0}
            max={100}
            maxLength={7}
            decimals={2}
            placeholder="0,00"
            isDisabled={false}
            name="per_gnn"
            register={register}
            control={control}
            isError={!!errors.per_gnn}
            showIcon
            onInput={(ev: any) => {
              const serializedValue = moedaFormatada(ev.target.value);
              setValue('per_gnn', serializedValue);
              clearErrors('per_glp');
            }}
          />
        </Col>
        <Col sm={2} md={2}>
          <InputPercent
            label="GNI"
            min={0}
            max={100}
            maxLength={7}
            decimals={2}
            placeholder="0,00"
            isDisabled={false}
            name="per_gni"
            register={register}
            control={control}
            isError={!!errors.per_gni}
            showIcon
            onInput={(ev: any) => {
              const serializedValue = moedaFormatada(ev.target.value);
              setValue('per_gni', serializedValue);
              clearErrors('per_glp');
            }}
          />
        </Col>

        <Col sm={2} md={2}>
          <InputMoney
            label="Valor Partida"
            placeholder="0,00"
            max={999999}
            maxLength={16}
            min={0}
            name="val_partida"
            id="val_partida"
            register={register}
            isError={!!errors.val_partida}
            showIcon
            control={control}
          />
        </Col>

        <Col sm={2} md={2}>
          <InputSelect
            label="Unidade Tributável"
            options={unidades.data?.unCompras as SelectType[]}
            name="des_unidade_tributavel"
            placeholder="Nenhum"
            register={register}
            isError={!!errors.des_unidade_tributavel}
            control={control}
            changeSelected={(selected) => {
              setValue('des_unidade_tributavel', selected);
              clearErrors('des_unidade_tributavel');
            }}
          />
        </Col>

        <Col sm={12} md={12}>
          <Separator labelText="iPDV" />
        </Col>

        <Col xs={12} sm={6} md={3} lg={3} xl={2}>
          <ToggleDefault
            labelText="Permite Parcelamento?"
            setChecked={flags.flg_permite_parc}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_permite_parc: !prev.flg_permite_parc,
              }));
            }}
          />
        </Col>
        <Col xs={12} sm={6} md={3} lg={2} xl={2}>
          <ToggleDefault
            labelText="Emite Vale Gás?"
            setChecked={flags.flg_vale_gas}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_vale_gas: !prev.flg_vale_gas,
              }));
            }}
          />
        </Col>
        <Col xs={12} sm={6} md={3} lg={2} xl={2}>
          <ToggleDefault
            labelText="Pede Liberação Fiscal?"
            setChecked={flags.flg_lib_fiscal}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_lib_fiscal: !prev.flg_lib_fiscal,
              }));
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12}>
          <Separator labelText="Rastreabilidade" />
        </Col>
        <Col xs={12} sm={6} md={3} lg={2} xl={2}>
          <ToggleDefault
            labelText="Item Rastreável?"
            setChecked={flags.flg_rastreavel}
            onSwitch={() => handleChangeFlgRastreavel()}
          />
        </Col>
      </Row>
      <Row className={!flags.flg_rastreavel ? 'd-none' : ''}>
        <Col sm={12} md={3}>
          <InputText
            label="Número de Lote"
            maxLength={25}
            placeholder="Digite aqui o Número do Lote"
            isDisabled={!flags.flg_rastreavel}
            name="num_lote_rast"
            register={register}
            isError={!!errors.num_lote_rast}
            autoComplete="off"
          />
        </Col>
        <Col sm={12} md={2}>
          <InputNumber2
            label="Quantidade"
            min={1}
            max={999999999}
            placeholder=""
            maxLength={9}
            disabled={!flags.flg_rastreavel}
            name="qtd_lote_rast"
            register={register}
            control={control}
            isError={!!errors.qtd_lote_rast}
            onBlur={(event: ChangeEvent<HTMLInputElement>) => {
              if (event.target.value === '') setValue('qtd_lote_rast', 0);
            }}
            onInput={(ev: any) => {
              const value = parseFloat(ev.target.value.slice(0, 9));

              if (value <= 999999999) {
                setValue('qtd_lote_rast', value);
              }
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputNumber2
            label="Código Agregação"
            min={0}
            max={999999999}
            placeholder=""
            maxLength={9}
            disabled={!flags.flg_rastreavel}
            name="cod_agreg_rast"
            register={register}
            control={control}
            isError={!!errors.cod_agreg_rast}
            onInput={(ev: any) => {
              const value = parseFloat(ev.target.value.slice(0, 9));

              if (value <= 999999999) {
                setValue('cod_agreg_rast', value);
              }
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputDate
            label="Data de Fabricação"
            name="dta_fabricacao_rast"
            control={control}
            register={register}
            isError={!!errors.dta_fabricacao_rast}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              clearErrors('dta_fabricacao_rast');
              setValue('dta_fabricacao_rast', e.target.value);
            }}
          />
        </Col>
      </Row>
    </InterfaceContainer>
  );
};
